import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Breadcrumbs, Crumb } from '@carsys/ui'
import {
  rentalVehiclesAddContractURL,
  rentalVehiclesAddURL,
  rentalVehiclesContractsURL,
  rentalVehiclesDetailsURL,
  rentalVehiclesEditContractURL,
  rentalVehiclesInvoicesURL,
  rentalVehiclesURL
} from 'app/replacementVehicles/RouteConstants'
import { IRootReducerState } from 'state/rootReducer'
import { splitRegistration } from '@cbgms/base/utils/vehicle'

export const RentalVehiclesBreadCrumbs: React.FC<React.ComponentProps<typeof Breadcrumbs>> = ({ ...props }) => {
  const { t } = useTranslation()
  const vehicleRegistration = useSelector((state: IRootReducerState) => state.vehicle.detail.Registration)
  const registration = splitRegistration(vehicleRegistration)

  return (
    <Breadcrumbs {...props}>
      <Crumb
        data-testid='crumb-rental-vehicles-fleet'
        key='crumb-rental-vehicles-fleet'
        path={rentalVehiclesURL}
        text={t('ReplacementVehicles.RentalVehicles')}
      />
      <Crumb
        data-testid='crumb-rental-vehicles-details'
        key='crumb-rental-vehicles-details'
        path={rentalVehiclesDetailsURL}
        exact
        text={registration?.licensePlate ? `${t('vehicle.vehicle')} (${registration.licensePlate})` : t('vehicle.vehicle')}
      />
      <Crumb
        data-testid='crumb-rental-add-vehicles-fleet'
        key='crumb-rental-add-vehicles-fleet'
        path={rentalVehiclesAddURL}
        text={t('global.add')}
      />
      <Crumb
        data-testid='crumb-rental-contracts'
        key='crumb-rental-contracts'
        path={rentalVehiclesContractsURL}
        text={t('ReplacementVehicles.RentalContracts')}
      />
      <Crumb
        data-testid='crumb-rental-invoices'
        key='crumb-rental-invoices'
        path={rentalVehiclesInvoicesURL}
        text={t('ReplacementVehicles.RentalInvoices')}
      />
      <Crumb
        data-testid='crumb-add-rental-contract'
        path={rentalVehiclesAddContractURL}
        text={t('ReplacementVehicles.AddRentalContract')}
      />
      <Crumb
        data-testid='crumb-edit-rental-contract'
        key='crumb-edit-rental-contract'
        path={rentalVehiclesEditContractURL}
        text={t('ReplacementVehicles.EditRentalContract')}
      />
    </Breadcrumbs>
  )
}

export default RentalVehiclesBreadCrumbs
